export const funcWrap = (origFunc, newFunc) => {
	const savedFunc = origFunc;
	return newFunc(savedFunc);
};
